<div id="chipchecker" [class]="variant === 'purina' || variant === 'check-pet' ? 'purina-container' : ''" class="home-card p-3">
  <h3>Check a chip</h3>
  <p *ngIf="variant === 'purina'">
    Not sure which database holds your details? Just enter your microchip number and we’ll let you
    know straight away.
    <br />
    Enter your microchip number to check which UK database holds your details.
  </p>
  <div *ngIf="chipCheckerResults" class="text-center">
    <p [class]="'text-' + chipCheckerResults.type">
      {{ chipCheckerResults.message }}
    </p>
    <p *ngIf="chipCheckerResults.type === 'success'">
      <a
        *ngFor="let link of chipCheckerResults.links; let last = last"
        href="{{ link }}"
        target="_blank"
      >
        {{ link }}
        <span *ngIf="!last">
          ,
          <br />
        </span>
      </a>
    </p>
  </div>
  <form #chipCheckerForm="ngForm" (ngSubmit)="checkChip()" novalidate>
    <div class="form-check" *ngIf="variant === 'purina' || variant === 'check-pet'">
      <input
        *ngIf="variant === 'purina'"
        #checkChipAgree="ngModel"
        type="checkbox"
        class="form-check-input"
        id="checkChipAgree"
        name="checkChipAgree"
        ngModel=""
        required
      />
      <label class="form-check-label" for="checkChipAgree">
        <span class="small fw-bold" *ngIf="variant === 'purina'">
          By using this lookup you consent to identibase storing your IP address, which identibase
          will use for pet reuniting purposes. Please tick this box to indicate your agreement to us
          using your IP address for these purposes.
        </span>
        <span class="form-check-label-text" *ngIf="variant === 'check-pet'">
          By using this lookup you consent to identibase storing your IP address, which identibase will use solely for pet reuniting purposes. 
        </span>
      </label>
      <div *ngIf="variant === 'purina' || variant === 'check-pet'" class="mt-4 mt-sm-0">
        <button
          type="submit"
          class="btn btn-orange w-100"
          [disabled]="!chipCheckerForm.valid || chipCheckerLoading"
        >
          <fa-icon
            *ngIf="chipCheckerLoading"
            [icon]="['fas', 'spinner']"
            [animation]="'spin'"
            class="me-3"
          ></fa-icon>
          {{ chipCheckerLoading ? 'Checking...' : 'Check Chip' }}
        </button>
        <a
          class="h5 btn-link text-primary"
          href="https://identicare.zendesk.com/hc/en-gb/articles/10526002847005-How-do-I-find-my-pet-s-microchip-number"
          target="_blank"
        >
          Where can I find my pet's microchip number?
        </a>
      </div>
    </div>
    <div class="row mt-1">
      <div [class]="variant === 'purina' || variant === 'check-pet' ? 'w-100' : ''" class="col-sm-7 col-md-6 col-lg-7">
        <input
          #checkChipNumber="ngModel"
          type="text"
          class="form-control"
          placeholder="Enter your 15 digit chip number"
          id="checkChipNumber"
          name="checkChipNumber"
          [(ngModel)]="chipCheckerNumber"
          [disabled]="chipCheckerLoading"
          required
        />
      </div>
      <div *ngIf="variant !== 'purina' && variant !== 'check-pet'" class="col-sm-5 col-md-6 col-lg-5 mt-4 mt-sm-0">
        <button
          type="submit"
          class="btn btn-orange w-100"
          [disabled]="!chipCheckerForm.valid || chipCheckerLoading"
        >
          <fa-icon
            *ngIf="chipCheckerLoading"
            [icon]="['fas', 'spinner']"
            [animation]="'spin'"
            class="me-3"
          ></fa-icon>
          {{ chipCheckerLoading ? 'Checking...' : 'Check Chip' }}
        </button>
      </div>
    </div>
  </form>
</div>
